
import { Action } from '@ngrx/store';
import { IServiceOpcode, ISearchResult, IOpcodeCount, ISyncStatus, IOnlineCodeSortDetail } from '@signal/asp-data-commons';

export enum LoadDirection {
  UP = 'up',
  DOWN = 'down',
}

export enum OpCodeActionTypes {
  LOAD_ALL_OPCODES = '[OpCode Management] Load all opcodes',
  LOAD_ALL_OPCODES_SUCCESS = '[OpCode Management] Load all opcodes success',
  LOAD_ALL_OPCODES_FAILURE = '[OpCode Management] Load all opcodes failure',
  LOAD_ONLINE_OPCODES = '[OpCode Management] Load online opcodes',
  LOAD_ONLINE_OPCODES_SUCCESS = '[OpCode Management] Load online opcodes success',
  LOAD_ONLINE_OPCODES_FAILURE = '[OpCode Management] Load online opcodes failure',
  LOAD_MORE_OPCODES = '[OpCode Management] Load more opcodes',
  LOAD_MORE_OPCODES_SUCCESS = '[OpCode Management] Load more opcodes success',
  LOAD_MORE_OPCODES_FAILURE = '[OpCode Management] Load more opcodes failure',
  LOAD_OPCODE = '[OpCode Management] Select a service opcode',
  LOAD_OPCODE_SUCCESS = '[OpCode Management] Select a service opcode success',
  LOAD_OPCODE_FAILURE = '[OpCode Management] Select a service opcode failure',
  FETCH_OPCODE_BY_ID = '[OpCode Management] Fetch a service opcode by id for recommended services',
  FETCH_OPCODE_BY_ID_SUCCESS = '[OpCode Management] Fetch a service opcode by id for recommended services success',
  FETCH_OPCODE_BY_ID_FAILURE = '[OpCode Management] Fetch a service opcode by id for recommended services failure',
  LOAD_OPCODES_COUNT = '[OpCode Management] Load opcodes count',
  LOAD_OPCODES_COUNT_SUCCESS = '[OpCode Management] Load opcodes count success',
  LOAD_OPCODES_COUNT_FAILURE = '[OpCode Management] Load opcodes count failure',
  CREATE_OPCODE = '[OpCode Management] Create Opcode',
  CREATE_OPCODE_SUCCESS = '[OpCode Management] Create Opcode success',
  CREATE_OPCODE_FAILURE = '[OpCode Management] Create Opcode failure',
  CHECK_ALL_OPCODES = '[OpCode Management] Check all opcodes',
  CHECK_ALL_OPCODES_SUCCESS = '[OpCode Management] Check all opcodes success',
  CHECK_ALL_OPCODES_FAILURE = '[OpCode Management] Check all opcodes failure',
  CHANGE_IS_EXISTING_OPCODE = '[OpCode Management] Change Is Existing opcode',
  UPDATE_OPCODE = '[OpCode Management] Update Opcode',
  UPDATE_OPCODE_SUCCESS = '[OpCode Management] Update Opcode success',
  UPDATE_OPCODE_FAILURE = '[OpCode Management] Update Opcode failure',
  LOAD_MILEAGES = '[OpCode Management] Load all mileages',
  LOAD_MILEAGES_SUCCESS = '[OpCode Management] Load all mileages success',
  LOAD_MILEAGES_FAILURE = '[OpCode Management] Load all mileages failure',
  LOAD_ONLINE_SORT_ORDER = '[OpCode Management] Load online sort order',
  LOAD_ONLINE_SORT_ORDER_SUCCESS = '[OpCode Management] Load online sort order success',
  LOAD_ONLINE_SORT_ORDER_FAILURE = '[OpCode Management] Load online sort order failure',
  UPDATE_ONLINE_SORT_ORDER = '[OpCode Management] Update online sort order',
  UPDATE_ONLINE_SORT_ORDER_SUCCESS = '[OpCode Management] Update online sort order success',
  UPDATE_ONLINE_SORT_ORDER_FAILURE = '[OpCode Management] Update online sort order failure',
  LOAD_SYNC_STATUS = '[OpCode Management] Load sync status',
  LOAD_SYNC_STATUS_SUCCESS = '[OpCode Management] Load sync status success',
  LOAD_SYNC_STATUS_FAILURE = '[OpCode Management] Load sync status failure',
  UPDATE_FROM_DMS = '[OpCode Management] Update opcodes from DMS',
  UPDATE_FROM_DMS_SUCCESS = '[OpCode Management] Update opcodes from DMS success',
  UPDATE_FROM_DMS_FAILURE = '[OpCode Management] Update opcodes from DMS failure',
  CHANGE_IS_ASP_CODE_CREATED = '[OpCode Management] Change Is Asp Code Created',
  UPDATE_ASP_OPCODE_NAME = '[OpCode Management] Update ASP Opcode Name',
  UPDATE_ASP_OPCODE_NAME_SUCCESS = '[OpCode Management] Update ASP Opcode Name success',
  UPDATE_ASP_OPCODE_NAME_FAILURE = '[OpCode Management] Update ASP Opcode Name failure',
  DELETE_ASP_SERVICE_CODE = '[OpCode Management] Delete ASP Service Code',
  DELETE_ASP_SERVICE_CODE_SUCCESS = '[OpCode Management] Delete ASP Service Code Success',
  DELETE_ASP_SERVICE_CODE_FAIL = '[OpCode Management] Delete ASP Service Code Fail'
}

export class LoadAllOpCodes implements Action {
  readonly type: string = OpCodeActionTypes.LOAD_ALL_OPCODES;

  constructor(
    public payload: {
      order: string, sort: string,
      limit: string, query: string
    }) {
  }
}

export class LoadAllOpCodesSuccess implements Action {
  readonly type = OpCodeActionTypes.LOAD_ALL_OPCODES_SUCCESS;

  constructor(public payload: { opCodeDetails: ISearchResult<IServiceOpcode[]> }) {
  }
}

export class LoadAllOpCodesFailure implements Action {
  readonly type = OpCodeActionTypes.LOAD_ALL_OPCODES_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadOnlineOpCodes implements Action {
  readonly type: string = OpCodeActionTypes.LOAD_ONLINE_OPCODES;

  constructor(
    public payload: {
      order: string, sort: string,
      limit: string, query: string
    }) {
  }
}

export class LoadOnlineOpCodesSuccess implements Action {
  readonly type = OpCodeActionTypes.LOAD_ONLINE_OPCODES_SUCCESS;

  constructor(public payload: { opCodeDetails: ISearchResult<IServiceOpcode[]> }) {
  }
}

export class LoadOnlineOpCodesFailure implements Action {
  readonly type = OpCodeActionTypes.LOAD_ONLINE_OPCODES_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadMoreOpCodes implements Action {
  readonly type: string = OpCodeActionTypes.LOAD_MORE_OPCODES;

  constructor(
    public payload: {
      order: string, sort: string, offset: string,
      limit: string, direction: LoadDirection, query: string
    }) {
  }
}

export class LoadMoreOpCodesSuccess implements Action {
  readonly type = OpCodeActionTypes.LOAD_MORE_OPCODES_SUCCESS;

  constructor(public payload: { opCodeDetails: ISearchResult<IServiceOpcode[]>, direction: LoadDirection, offset: string }) {
  }
}

export class LoadMoreOpCodesFailure implements Action {
  readonly type = OpCodeActionTypes.LOAD_MORE_OPCODES_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadOpCode implements Action {
  readonly type: string = OpCodeActionTypes.LOAD_OPCODE;

  constructor(public payload: { opcode: string }) {
  }
}

export class LoadOpCodeSuccess implements Action {
  readonly type = OpCodeActionTypes.LOAD_OPCODE_SUCCESS;

  constructor(public payload: { service: IServiceOpcode }) {
  }
}

export class LoadOpCodeFailure implements Action {
  readonly type = OpCodeActionTypes.LOAD_OPCODE_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class FetchOpcodeById implements Action {
  readonly type: string = OpCodeActionTypes.FETCH_OPCODE_BY_ID;

  constructor(public payload: { opcode: string }) {
  }
}

export class FetchOpcodeByIdSuccess implements Action {
  readonly type = OpCodeActionTypes.FETCH_OPCODE_BY_ID_SUCCESS;

  constructor(public payload: { service: IServiceOpcode }) {
  }
}

export class FetchOpcodeByIdFailure implements Action {
  readonly type = OpCodeActionTypes.FETCH_OPCODE_BY_ID_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadOpCodesCount implements Action {
  readonly type: string = OpCodeActionTypes.LOAD_OPCODES_COUNT;

  constructor() { }
}

export class LoadOpCodesCountSuccess implements Action {
  readonly type = OpCodeActionTypes.LOAD_OPCODES_COUNT_SUCCESS;

  constructor(public payload: { opCodeCountDetails: IOpcodeCount }) {
  }
}

export class LoadOpCodesCountFailure implements Action {
  readonly type = OpCodeActionTypes.LOAD_OPCODES_COUNT_FAILURE;

  constructor(public payload: { error: string }) {
  }
}
export class CheckAllOpcodes implements Action {
  readonly type: string = OpCodeActionTypes.CHECK_ALL_OPCODES;

  constructor(
    public payload: {
      order: string, sort: string,
      limit: string, query: string
    }) {
  }
}

export class CheckAllOpcodesSuccess implements Action {
  readonly type = OpCodeActionTypes.CHECK_ALL_OPCODES_SUCCESS;

  constructor(public payload: { opCodeDetails: ISearchResult<IServiceOpcode[]>, query: string}) {
  }
}

export class CheckAllOpcodesFailure implements Action {
  readonly type = OpCodeActionTypes.CHECK_ALL_OPCODES_FAILURE;

  constructor(public payload: { error: string }) {
  }
}
export class ChangeIsExistingOpcode implements Action {
  readonly type: string = OpCodeActionTypes.CHANGE_IS_EXISTING_OPCODE;

  constructor() { }
}

export class CreateOpCode implements Action {
  readonly type = OpCodeActionTypes.CREATE_OPCODE;

  constructor(public payload: { opcode: IServiceOpcode }) {
  }
}

export class CreateOpCodeSuccess implements Action {
  readonly type = OpCodeActionTypes.CREATE_OPCODE_SUCCESS;

  constructor(public payload: { opcode: IServiceOpcode }) {
  }
}
export class CreateOpCodeFailure implements Action {
  readonly type = OpCodeActionTypes.CREATE_OPCODE_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class UpdateOpCode implements Action {
  readonly type = OpCodeActionTypes.UPDATE_OPCODE;

  constructor(public payload: { opcode: IServiceOpcode, isLoadNotificationData?: boolean }) {
  }
}

export class UpdateOpCodeSuccess implements Action {
  readonly type = OpCodeActionTypes.UPDATE_OPCODE_SUCCESS;

  constructor(public payload: { opcode: IServiceOpcode }) {
  }
}

export class UpdateOpCodeFailure implements Action {
  readonly type = OpCodeActionTypes.UPDATE_OPCODE_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadMileages implements Action {
  readonly type: string = OpCodeActionTypes.LOAD_MILEAGES;

  constructor() {
  }
}

export class LoadMileagesSuccess implements Action {
  readonly type = OpCodeActionTypes.LOAD_MILEAGES_SUCCESS;

  constructor(public payload: { mileages: number[] }) {

  }
}

export class LoadMileagesFailure implements Action {
  readonly type = OpCodeActionTypes.LOAD_MILEAGES_FAILURE;

  constructor(public payload: { error: string }) {

  }
}

export class LoadOnlineSortOrder implements Action {
  readonly type: string = OpCodeActionTypes.LOAD_ONLINE_SORT_ORDER;

  constructor() {
  }
}

export class LoadOnlineSortOrderSuccess implements Action {
  readonly type = OpCodeActionTypes.LOAD_ONLINE_SORT_ORDER_SUCCESS;

  constructor(public payload: { onlineSortOrder: IOnlineCodeSortDetail }) {

  }
}

export class LoadOnlineSortOrderFailure implements Action {
  readonly type = OpCodeActionTypes.LOAD_ONLINE_SORT_ORDER_FAILURE;

  constructor(public payload: { error: string }) {

  }
}

export class UpdateOnlineSortOrder implements Action {
  readonly type = OpCodeActionTypes.UPDATE_ONLINE_SORT_ORDER;

  constructor(public payload: { onlineSortOrder: IOnlineCodeSortDetail }) {
  }
}

export class UpdateOnlineSortOrderSuccess implements Action {
  readonly type = OpCodeActionTypes.UPDATE_ONLINE_SORT_ORDER_SUCCESS;

  constructor(public payload: { onlineSortOrder: IOnlineCodeSortDetail }) {
  }
}

export class UpdateOnlineSortOrderFailure implements Action {
  readonly type = OpCodeActionTypes.UPDATE_ONLINE_SORT_ORDER_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadSyncStatus implements Action {
  readonly type: string = OpCodeActionTypes.LOAD_SYNC_STATUS;

  constructor() {
  }
}

export class LoadSyncStatusSuccess implements Action {
  readonly type = OpCodeActionTypes.LOAD_SYNC_STATUS_SUCCESS;

  constructor(public payload: { status: ISyncStatus }) {

  }
}

export class LoadSyncStatusFailure implements Action {
  readonly type = OpCodeActionTypes.LOAD_SYNC_STATUS_FAILURE;

  constructor(public payload: { error: string }) {

  }
}

export class UpdateFromDms implements Action {
  readonly type = OpCodeActionTypes.UPDATE_FROM_DMS;

  constructor() {
  }
}

export class UpdateFromDmsSuccess implements Action {
  readonly type = OpCodeActionTypes.UPDATE_FROM_DMS_SUCCESS;

  constructor(public payload: { status: ISyncStatus }) {
  }
}

export class UpdateFromDmsFailure implements Action {
  readonly type = OpCodeActionTypes.UPDATE_FROM_DMS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class ChangeIsAspCodeCreated implements Action {
  readonly type: string = OpCodeActionTypes.CHANGE_IS_ASP_CODE_CREATED;

  constructor() { }
}

export class UpdateAspOpCodeName implements Action {
  readonly type = OpCodeActionTypes.UPDATE_ASP_OPCODE_NAME;

  constructor(public payload: { aspServiceCode:string, opcode: IServiceOpcode }) {
  }
}

export class UpdateAspOpCodeNameSuccess implements Action {
  readonly type = OpCodeActionTypes.UPDATE_ASP_OPCODE_NAME_SUCCESS;

  constructor(public payload: { aspServiceCode:string, opcode: IServiceOpcode }) {
  }
}

export class UpdateAspOpCodeNameFailure implements Action {
  readonly type = OpCodeActionTypes.UPDATE_ASP_OPCODE_NAME_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class DeleteAspServiceCode implements Action {
  readonly type = OpCodeActionTypes.DELETE_ASP_SERVICE_CODE;

  constructor(public payload: {aspServiceCode: string}) {}
}

export class DeleteAspServiceCodeSuccess implements Action {
  readonly type = OpCodeActionTypes.DELETE_ASP_SERVICE_CODE_SUCCESS;

  constructor(public payload: { opcode: IServiceOpcode }) {}
}

export class DeleteAspServiceCodeFail implements Action {
  readonly type = OpCodeActionTypes.DELETE_ASP_SERVICE_CODE_FAIL;

  constructor(public payload: { error: string }) {
  }
}

export type OpCodeActions =
  LoadAllOpCodes
  | LoadAllOpCodesSuccess
  | LoadAllOpCodesFailure
  | LoadOnlineOpCodes
  | LoadOnlineOpCodesSuccess
  | LoadOnlineOpCodesFailure
  | LoadOpCode
  | LoadOpCodeSuccess
  | LoadOpCodeFailure
  | FetchOpcodeById
  | FetchOpcodeByIdSuccess
  | FetchOpcodeByIdFailure
  | LoadMoreOpCodes
  | LoadMoreOpCodesSuccess
  | LoadMoreOpCodesFailure
  | LoadOpCodesCount
  | LoadOpCodesCountSuccess
  | LoadOpCodesCountFailure
  | UpdateOpCode
  | UpdateOpCodeSuccess
  | UpdateOpCodeFailure
  | LoadMileages
  | LoadMileagesSuccess
  | LoadMileagesFailure
  | LoadOnlineSortOrder
  | LoadOnlineSortOrderSuccess
  | LoadOnlineSortOrderFailure
  | UpdateOnlineSortOrder
  | UpdateOnlineSortOrderSuccess
  | UpdateOnlineSortOrderFailure
  | LoadSyncStatus
  | LoadSyncStatusSuccess
  | LoadSyncStatusFailure
  | UpdateFromDms
  | UpdateFromDmsSuccess
  | UpdateFromDmsFailure
